
import { useMemo } from "react";
import { Candidate } from "@/types/candidate";

interface CandidatesSkillsExtractorProps {
  candidates: Candidate[];
}

export const CandidatesSkillsExtractor = ({ candidates }: CandidatesSkillsExtractorProps) => {
  // Get unique skills from candidates for filter options
  const allSkills = useMemo(() => {
    const skillsSet = new Set<string>();
    candidates.forEach(candidate => {
      if (candidate.skills) {
        candidate.skills.forEach(skill => skillsSet.add(skill));
      }
    });
    return Array.from(skillsSet).sort();
  }, [candidates]);

  return allSkills;
};
